import React from 'react';
import positiveIconImage from '../../static/images/icon_positive.png';
const AppIcon = () => (React.createElement("img", { src: positiveIconImage, alt: "Numereyes", width: "56px", height: "auto" }));
export default AppIcon;
